export default __webpack_public_path__ + "static/media/I-2020.3ec174df.pdf";